export const TESTIMONIALS_SECTION_STYLES = {
  root: "w-full",
  title: "text-[20px] md:text-[24px] font-bold text-ticketon-dark-text",
  description: "mt-2 text-[13px] text-ticketon-gray-600",
  grid: "mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3",
  card: "flex flex-col gap-3 rounded-[16px] bg-white p-5 shadow-ticketon-card",
  stars: "flex items-center gap-0.5 text-ticketon-yellow",
  star: "text-[18px] leading-none",
  starActive: "text-ticketon-yellow",
  starInactive: "text-ticketon-light-gray",
  quote: "text-[14px] leading-relaxed text-ticketon-dark-text",
  author: "flex items-center gap-3",
  avatar: "h-10 w-10 rounded-full object-cover bg-ticketon-gray-bg",
  authorInfo: "flex flex-col",
  authorName: "text-[13px] font-semibold text-ticketon-dark-text",
  authorRole: "text-[11px] text-ticketon-gray-600",
} as const;
